const LIMITED_ITEMS = {
    analytics: {
        fullPermission: "analytics",
        limitedPermission: "limitedViewAnalytics",
    },
    profile: {
        fullPermission: "profile",
        limitedPermission: "limitedViewProfile",
    },
    courses: {
        fullPermission: "courses",
        limitedPermission: "limitedViewCourses",
    },
    transcript: {
        fullPermission: "transcript",
        limitedPermission: "limitedViewTranscript",
    },
    testScores: {
        fullPermission: "testScores",
        limitedPermission: "limitedViewTestScores",
    },
    finances: {
        fullPermission: "finances",
        limitedPermission: "limitedViewFinances",
    },
    notes: {
        fullPermission: "notes",
        limitedPermission: "limitedViewNotes",
    },
    meetings: {
        fullPermission: "meetings",
        limitedPermission: "limitedViewMeetings",
    },
    documents: {
        fullPermission: "documents",
        limitedPermission: "limitedViewDocuments",
    },
    activity: {
        fullPermission: "activity",
        limitedPermission: "limitedViewActivity",
    },
    surveys: {
        fullPermission: "surveys",
        limitedPermission: "limitedViewSurveys",
    },
    tasks: {
        fullPermission: "tasks",
        limitedPermission: "limitedViewTasks",
    },
    applications: {
        fullPermission: "applications",
        limitedPermission: "limitedViewApplications",
    },
    programs: {
        fullPermission: "programs",
        limitedPermission: "limitedViewPrograms",
    },
    alerts: {
        fullPermission: "alerts",
        limitedPermission: "limitedViewAlerts",
    },
    messages: {
        fullPermission: "messages",
        limitedPermission: "limitedViewMessages",
    },
    pipelines: {
        fullPermission: "pipelines",
        limitedPermission: "limitedViewPipelines",
    },
    phoneCalls: {
        fullPermission: "phoneCalls",
        limitedPermission: "limitedViewPhoneCalls",
    },
    forms: {
        fullPermission: "forms",
        limitedPermission: "limitedViewForms",
    },
};
/**
 * This method should be used to determine if the user can
 * see a given tab based on caseload and permissions.
 */
export default class LimitedPermissionUtility {
    // eslint-disable-next-line no-dupe-args
    static canSeeTab({ tab, tabPermissions, userIsOnCase, canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload, }) {
        // The full profile can be seen if the visible user is on our caseload and
        // we have permission to see the full profile for all students or for students on our caseload, or
        // if the student is not on our caseload and we have permission to see the full profile for all students
        const fullProfileView = userIsOnCase
            ? canSeeFullProfileForAllStudents || canSeeFullProfileForMyCaseload
            : canSeeFullProfileForAllStudents;
        // if we have fullProfileView for the student, use item.fullPermission
        // otherwise use item.limitedPermission to check against tabPermissions
        const itemPermission = fullProfileView
            ? LIMITED_ITEMS[tab].fullPermission
            : LIMITED_ITEMS[tab].limitedPermission;
        return tabPermissions[itemPermission];
    }
}
